<template>
    <div class="container-detail">
        <div class="detail-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к списку заседаний
            </v-btn>
            <div>
                <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
                    Редактировать
                </v-btn>
            </div>

        </div>

        <div class="detail-main">
            <div class="detail-main-first-container" v-if="meeting">
                <div class="first-container-box">
                    <div class="container-box-title">
                        Название
                    </div>
                    <div class="container-box-text">
                        {{ meeting.title }}
                    </div>
                </div>
                <div class="first-container-box">
                    <div class="container-box-title">
                        Текст
                    </div>
                    <div class="container-box-text">
                        {{ meeting.text }}
                    </div>
                </div>


                <div class="first-container-box">
                    <div class="container-box-title">
                        Дата заседания
                    </div>
                    <div class="container-box-text">
                        {{ meeting.date | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                </div>


                <div class="first-container-box">
                    <div class="container-box-title">
                        Отчеты
                    </div>
                    <div class="container-box-text">
                        <div v-for="(item, index) in meeting.files" :key="index">
                            <v-icon> mdi-file-pdf-box </v-icon>
                            <a style="margin-left:8px" target="_blank" :href="item.file">{{ item.name }}</a>
                        </div>



                    </div>
                </div>



            </div>
            <div class="detail-main-second-container">
                <div class="second-container-box">
                    <div class="container-box-title">
                        Изображение
                        <v-icon @mouseover="openInfoImg($event)" @mouseleave="showInfoImg = false" color="#E0E0E0">
                            mdi-information
                        </v-icon>

                    </div>
                    <v-menu v-model="showInfoImg" :position-x="xImg" :position-y="yImg" absolute offset-y>
                        <v-card>
                            <div class="menu-container">
                                <div class="menu-container-text">
                                    Нажмите на изображение, чтобы увидеть его в полном размере
                                </div>
                            </div>

                        </v-card>
                    </v-menu>

                </div>

                <div>
                    <v-simple-table v-if="meeting">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Формат
                                    </th>
                                    <th class="text-left">
                                        Место отображенния
                                    </th>
                                    <th class="text-left">
                                        Для смартфонов
                                    </th>
                                    <th class="text-left">
                                        Для планшетов
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr style="height: 60px;">
                                    <td class="text-left">Главное изображение</td>
                                    <td class="text-left">Отображается в подробной информации о заседании, над текстом</td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(meeting.smartphoneImage)" v-if="meeting.smartphoneImage"
                                            class="table-img" :src="meeting.smartphoneImage">
                                    </td>
                                    <td class="text-left">
                                        <img @click="openDialogImg(meeting.tabletImage)" v-if="meeting.tabletImage"
                                            class="table-img" :src="meeting.tabletImage">
                                    </td>
                                </tr>




                            </tbody>
                        </template>
                    </v-simple-table>

                    <DialogImage v-model="dialogImg" :src="previewImage" />
                    <v-divider></v-divider>
                </div>



            </div>


        </div>
    </div>
</template>
<script>


export default {

    data: () => ({
        meeting: null,
        dialogImg: false,
        previewImage: null,
        imageWidth: 0,


        showInfoImg: false,
        xImg: null,
        yImg: null,



    }),
    methods: {

        openInfoImg(e) {
            e.preventDefault()
            this.xImg = e.clientX + 10
            this.yImg = e.clientY + 10
            this.showInfoImg = true

        },


        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        back() {
            this.$router.push({ name: 'CouncilActivity', params: { selectedTicker: 1 } })
        },
        goToEdit() {
            this.$router.push({ name: 'EditMeeting', params: { id: this.$route.params.id } })
        },
        getMeeting() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/activity/meeting', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    meetingId: this.$route.params.id

                }
            })
                .then(res => {
                    this.meeting = res.data



                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        }
    },
    created() {
        this.getMeeting()
    }
}
</script>
<style lang="scss" scoped>
.container-detail {
    box-sizing: border-box;
    padding: 40px !important;

    .detail-header-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .detail-main {
        display: flex;
        justify-content: space-between;

        .detail-main-first-container {
            width: 48%;

            .first-container-box {

                margin-bottom: 40px;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }

                .container-box-text-list {
                    .container-box-text-list-item {
                        display: flex;
                        margin-bottom: 5px;

                        .list-item-subtitle {
                            font-size: 16px;
                            font-weight: 600;
                            color: #929292;
                            width: 200px;
                        }

                        .list-item-text {
                            font-size: 18px;
                            font-weight: 400;
                        }

                    }
                }
            }
        }

        .detail-main-second-container {
            width: 48%;

            .table-img {
                cursor: pointer;
                height: 38px;
                object-fit: contain;
            }

            .second-container-box {
                width: 100%;

                .container-box-title {
                    font-size: 24px;
                    font-weight: 600;

                }

                .container-box-text {
                    font-size: 18px;
                    font-weight: 400;

                }

                .container-box-onlytext {
                    margin-top: 10px;
                }
            }
        }

    }
}
</style>